import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeFirebaseData } from './firebase/initFirebase';
import { Toaster } from 'react-hot-toast';
import { QueryProvider } from './contexts/QueryProvider';

// Initialize Firebase data before rendering the app
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Show a loading indicator while Firebase initializes
root.render(
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontFamily: 'system-ui, -apple-system, sans-serif'
  }}>
    <div>Loading...</div>
  </div>
);

// Wait for Firebase to initialize before rendering the app
initializeFirebaseData()
  .then(() => {
    root.render(
      <React.StrictMode>
        <QueryProvider>
          <Toaster position="bottom-right" />
          <App />
        </QueryProvider>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error('Failed to initialize Firebase:', error);
    root.render(
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div>Failed to initialize application</div>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
